/* eslint semi:0 */
import { fetchCounters, getActionProviderHosts, NO_HOST } from './actionCounterBaseProvider'
import { route } from 'mithril'
import { getJsonOrError, getResponseText } from '../../utils/fetch'
import { getPostId, get as getFromPdo } from '../../application/pageDataObject'

const POST_METADATA = `Post_${getPostId()}`
const REACTIONS = `PostReactions_${getPostId()}`

const ACTION_COUNTER_KEYS = [REACTIONS, POST_METADATA]

function canSendData() {
  const hostsUrls = getActionProviderHosts()
  const reportingTargets = Object.keys(hostsUrls).map(k => hostsUrls[k])
  return !reportingTargets.includes(NO_HOST)
}

function fetchCounterByKey(key) {
  return fetchCounters(ACTION_COUNTER_KEYS).then(counters => counters[key])
}

export function fetchReactions() {
  return fetchCounterByKey(REACTIONS)
}

export function fetchPostMetadata() {
  return fetchCounterByKey(POST_METADATA)
}

export function sendData(type, params = {}) {
  if (!canSendData()) {
    return Promise.reject('cannot report to action counter.')
  }

  params.ts = Date.now()
  const { WRITER_ACTION_PROVIDER: baseUrl } = getActionProviderHosts()
  const serializedParams = route.buildQueryString(params)
  const url = `//${baseUrl}/${type}?${serializedParams}`
  return getResponseText(url)
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/providers/actionCounter/currentPostActionCounterProvider.js